(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Gedcom", [], factory);
	else if(typeof exports === 'object')
		exports["Gedcom"] = factory();
	else
		root["Gedcom"] = factory();
})(self, function() {
return 